import React from "react";
import PropTypes from "prop-types";
import { Tabs, Tab } from "@td/ui";
import { translate } from "@td/shared_utils";
import { useCategories } from "../contexts/categories-context";

const CategoryFilter = React.memo(({ value, onChange }) => {
  const categories = useCategories();

  return (
    <Tabs
      value={value}
      onChange={onChange}
      data-testid="category-filters"
    >
      {Object.keys(categories).map((category) => (
        <Tab
          key={category}
          value={categories[category]}
          data-testid="tab-category"
        >
          {translate(null, "care_team_tasks.categories", category)}
        </Tab>
      ))}
      <Tab
        key="all"
        value={null}
        data-testid="tab-all"
      >
        {translate(null, "care_team_tasks.tabs", "all")}
      </Tab>
    </Tabs>
  );
});

CategoryFilter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default CategoryFilter;
